/* @flow */

import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import { agreeToTerms, userSignOut } from 'app/actions/userActions';
import t from 'app/utils/translate';
import MessageModal from 'app/components/user/MessageModal';

function mapStateToProps({ user }): Object {
  const {
    isSignedIn,
    validationErrors: [error]
  } = user;

  return {
    cancelText: isSignedIn ? t('Log out') : t('Close'),
    confirmText: t('I agree'),
    isOpen: true,
    message: get(error, 'message', t('An error occurred.')),
    messageTitle: t('Important Notice'),
    shouldCloseOnOverlayClick: false,
    textAlign: 'left'
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>, { history }) {
  return {
    onCancel() {
      history.push('/');
      dispatch(userSignOut());
    },
    onConfirm() {
      dispatch(agreeToTerms());
    }
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MessageModal));
